import request from "./../utils/request";
import StringUtils from "../utils/StringUtils";

import store from "../store";
import TimeUtils from "../utils/TimeUtils";

console.log("store", store);
const cache = {};
const clearOldKeys = () => {
    const latestReportKey = store.state.app.reportCacheKey;
    const keys = Object.keys(cache);
    keys.forEach((key) => {
        if (!key.startsWith(latestReportKey)) {
            delete cache[key];
        }
    });
};
const cacheWrapper = (requestCallback, reportKey, data) => {
    const latestReportKey = store.state.app.reportCacheKey;
    const hashcode = StringUtils.hashCodeObj(data || {});
    const key = `${latestReportKey}_${reportKey}_${hashcode}`;
    if (cache[key]) {
        return Promise.resolve(cache[key]);
    }
    return requestCallback(data).then((response) => {
        cache[key] = response.data;
        clearOldKeys();
        return response.data;
    });
};

export async function getStatistics(data) {
    return request.post("/statistics", data, {
        timeout: 60 * 1000 * 5,
    });
}

export async function getAgentActivities(data) {
    return request.post("/statistics/agent-activities", data, {
        timeout: 60 * 1000 * 5,
    });
}

export const REPORT_API = {
    sessionOverall: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/session-overall", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "sessionOverall",
            data
        );
    },
    ratingOverall: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/rating-overall", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "ratingOverall",
            data
        );
    },
    sessionDurationOverall: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/session-duration-overall", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "sessionDurationOverall",
            data
        );
    },
    chatDistributionsAll: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/chat-distributions", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "chatDistributionsAll",
            data
        );
    },
    calculateStats: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/overall-stats", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "calculateStats",
            data
        );
    },
    resolveTimeByUser: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/resolve-time-by-user", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "resolveTimeByUser",
            data
        );
    },
    firstInteractionTimeByUser: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/first-interaction-time-by-user", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "firstInteractionTimeByUser",
            data
        );
    },
    agentPerformanceAll: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/agent-performance", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "agentPerformanceAll",
            data
        );
    },
    teamWorkCalendar: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/team-work-calendar", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "teamWorkCalendar",
            data
        );
    },
    websiteTraffic: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/website-traffic", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "websiteTraffic",
            data
        );
    },

    websiteTrafficByCountry: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/website-traffic-by-country", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "websiteTrafficByCountry",
            data
        );
    },
    channelOverall: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/channel-overall", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "channelOverall",
            data
        );
    },
    agentWaitDurationTimeseries: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/agent-wait-duration-timeseries", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "agentWaitDurationTimeseries",
            data
        );
    },
    topWorstComments: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/top-worst-comments", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "topWorstComments",
            data
        );
    },
    topBestComments: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/top-best-comments", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "topBestComments",
            data
        );
    },
    wabaMessageTraffic: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/waba-message-traffic", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "wabaMessageTraffic",
            data
        );
    },
    walletStatus: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/wallet-status", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "walletStatus",
            data
        );
    },
    calendarEvents: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/calendar-events", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "calendarEvents",
            data
        );
    },
    reservationEvents: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/reservation-events", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "reservationEvents",
            data
        );
    },
    mailInboxCounts: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/mail-inbox-counts", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "mailInboxCounts",
            data
        );
    },
    mailSendCounts: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/mail-send-counts", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "mailInboxCounts",
            data
        );
    },
    ticketDistributionsAll: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/ticket-distributions-all", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "ticketDistributionsAll",
            data
        );
    },
    taskOverall: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/task-overall", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "taskOverall",
            data
        );
    },
};

export const ADMIN_REPORT_API = {
    CUSTOMER_CANDIDATE: {
        getFunnelsBySource: async (data) => {
            data.timezone = TimeUtils.getTimezone();
            return cacheWrapper(
                () =>
                    request.post("/statistics/master/customer-candidate/funnels", data, {
                        timeout: 60 * 1000 * 5,
                    }),
                "getFunnelsBySource",
                data
            );
        },
        getBreakdowns: async (data) => {
            data.timezone = TimeUtils.getTimezone();
            return cacheWrapper(
                () =>
                    request.post("/statistics/master/customer-candidate/breakdowns", data, {
                        timeout: 60 * 1000 * 5,
                    }),
                "getBreakdowns",
                data
            );
        },
    },
    siteCounts: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/site-counts", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "siteCounts",
            data
        );
    },
    siteAgentsTimeseries: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/site-agent-timeseries", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "siteAgentsTimeseries",
            data
        );
    },
    siteAgentsBubble: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/site-agent-bubble", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "siteAgentsBubble",
            data
        );
    },
    paymentMethodsSites: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/payment-methods-sites", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "getPaymentTypeSites",
            data
        );
    },
    paidTypeSites: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/paid-type-sites", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "paidTypeSites",
            data
        );
    },
    paymentStatusSites: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/payment-status-sites", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "paymentStatusSites",
            data
        );
    },
    getSiteCountByPartnerTypes: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/site-counts-partner-types", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "getSiteCountByPartnerTypes",
            data
        );
    },
    usePlanGroup: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/master/plan/use-plan-group", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "usePlanGroup",
            data
        );
    },
    gainBalance: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/gain-balance", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "gainBalance",
            data
        );
    },
    spendBalance: async (data) => {
        data.timezone = TimeUtils.getTimezone();
        return cacheWrapper(
            () =>
                request.post("/statistics/spend-balance", data, {
                    timeout: 60 * 1000 * 5,
                }),
            "spendBalance",
            data
        );
    },
};
